import React from "react";
import "./ShippingPolicy.css";

const WeightSlabTable = () => {
    const weightData = [
        { slab: "0-500 Grams", local: 9, zonal: 21, national: 51 },
        { slab: "500 Grams – Up to 1 Kg", local: 15, zonal: 32, national: 62 },
        { slab: "+1 Kg – Up to 1.5 Kg", local: 21, zonal: 43, national: 73 },
        { slab: "+1.5 Kg – Up to 2 Kg", local: 27, zonal: 54, national: 79 },
        { slab: "+ 2 Kg - Up to 3 Kg (For Every 0.5 Grams)", local: 6, zonal: 8, national: 38 },
        { slab: "+ 3 Kg - Up to 10 Kg (For Every 1 Kg)", local: 13, zonal: 27, national: 46 },
        { slab: "+ 10 Kg - Up to 25 Kg (For Every 1 Kg)", local: 9, zonal: 20, national: 34 },
        { slab: "+25 Kg - Up to 50 Kg (For Every 1 Kg)", local: 8, zonal: 19, national: 33 },
    ];
const cellStyle = {
  fontSize: "16px"
};

    return (
        <div className="weight-container">

            <p style={{ fontSize: "20px" }}>
                We're delighted to offer shipping services across India, ensuring that our products reach customers far and wide. The shipping fee is calculated based on the actual weight of the product or the volumetric weight, whichever is higher. Volumetric weight accounts for items that are lightweight but occupy a significant amount of shipping space. This approach ensures fair and accurate shipping charges are applied, taking into consideration the actual or volumetric weight of the products being shipped.

                <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                    The shipping fee varies for the selected category.
                </p>

            </p>

            <table className="weight-table">
                <thead>
                <tr>
            <th colSpan={4} className="formula">
              Volumetric Weight (Kg) = Length (cm) × Breadth (cm) × Height (cm) / 5000
            </th>
          </tr>
                        {/* <th>Volumetric Weight (Kg) = Length (cm) × Breadth (cm) × Height (cm) / 5000</th> */}
                
                    <tr>
                        <th >Weight Slab</th>
                        <th>Local</th>
                        <th>Zonal</th>
                        <th>National</th>
                    </tr>
                </thead>
                <tbody>
                    {weightData.map((row, index) => (
                        <tr key={index}>
                            <td>{row.slab}</td>
                            <td>{row.local}</td>
                            <td>{row.zonal}</td>
                            <td>{row.national}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p style={{ fontSize: "14px", lineHeight: "1.8", color: "#333", margin: "20px 0" }}>
  Kindly note that these terms are subject to change at the discretion of the company.
  Our standard practice is to dispatch packages within 48 working hours, excluding Sundays.
  Following shipment, you can expect your order to arrive within 7–10 days; for made-to-order items, the duration might vary as specified in the listing.
  The estimated delivery time provided on our shipping page is indicative and reliant on our shipping partner.
  <br /><br />
  It is important to acknowledge that delivery times are influenced by factors such as location, distance, and the efficiency of our logistics partners.
  While we cannot be held responsible for any delays caused by courier companies or postal authorities,
  we will assist you in tracking your package through our partner courier services.
  <br /><br />
  Please be aware that your items may be shipped from multiple locations in separate packages;
  however, you will only be charged a single delivery fee for your entire order.
  As soon as your package is shipped, we will send you an email containing the necessary tracking information.
  <br /><br />
  If you have any specific requirements regarding time-bound deliveries, kindly communicate with us via email
  and leave comments indicating your requested delivery time during the ordering process.
  While we will make every effort to fulfil your order within the requested time frame,
  we cannot guarantee immediate compliance.
  <br /><br />
  <span style={{ fontWeight: "bold" }}>Powered by My Ace Bazaar Pvt Ltd.</span>
</p>

        </div>
    );
};

export default WeightSlabTable;

